var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_vm._v(" "),_c('main',{attrs:{"role":"main"}},[_c('div',[_vm._t("default")],2)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',{attrs:{"role":"banner"}},[_c('h1',[_c('span',[_vm._v("Moving Buddies")])])])
}]

export { render, staticRenderFns }